import React from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log details so lint won't complain about unused args
    // In production you might forward this to an error tracking service
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0b0f1a', color: '#ff6b6b'}}>
          <div style={{textAlign: 'center'}}>
            <h2 style={{marginBottom: 8}}>Something went wrong.</h2>
            <pre style={{whiteSpace: 'pre-wrap', textAlign: 'left', maxWidth: 800, color: '#ffd7d7'}}>{String(this.state.error)}</pre>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
